module.exports = __webpack_public_path__ + "static/img/s2.ba0940e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s2.png
// module id = cTLX
// module chunks = 1